/**
 * Store segment module.
 *
 * @module store/audiences/segment/module
 * @author Dilan Useche <dilan8810@gmail.com>
 * */

import actions from './segment.actions';

/**
 * export default
 *  @type {VuexModule}
 * */
export default {
  namespaced: true,
  actions,
};
